import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
export default Vue.extend({
    components: { ToolBar },
    name: "LessonBeginnerEnd"
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/lesson/LessonBeginnerEnd.vue
// module id = 642
// module chunks = 1